<template>
  <div class="container tem001">
    <HeadingOne>お申し込み完了</HeadingOne>

    <WizardGroup class="-margin-md">
      <MainWizard :active-index="3" type="useridentity"></MainWizard>
    </WizardGroup>

    <template v-if="isNeedIncome">
      <StepPage class="-success">
        <StepHeader>
          <img
            src="@/assets/images/icons/check-ok.svg"
            class="_i-w-sm-37 _i-w-md-74 _mb-sm-15 _mb-md-30"
            alt=""
          />
          <h2 class="heading">
            ご本人さま確認書類のアップロードが完了しました。
          </h2>
          <p class="_mb-0">
            続いて、収入証明書のご提出のお手続きをお願いします。<br />「次へ」を押してください。
          </p>
        </StepHeader>
      </StepPage>
      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal" router-name="en017"> 次へ </BtnMain>
      </BtngroupSingle>
    </template>

    <template v-else>
      <StepPage class="-success">
        <StepHeader class="complete">
          <img
            src="@/assets/images/icons/check-ok.svg"
            class="_i-w-sm-37 _i-w-md-74 _mb-sm-15 _mb-md-30"
            alt=""
          />
          <h2 class="heading">
            ご本人さま確認書類のアップロードが完了しました。<br />ありがとうございました。
          </h2>
          <p class="_mb-0">
            審査が完了次第、ご登録いただいたメールアドレスにご案内をお送りいたします。
          </p>
          <small class="complete-note"
            >※ 下記電話番号よりお電話を差し上げることがございます。<br />･ご入力された情報に不備があった場合<br />･当社がお客さまに確認が必要と判断した場合</small
          >
        </StepHeader>
        <TelBox></TelBox>
      </StepPage>
      <BtngroupSingle class="-margin-lg">
        <BtnMain class="-normal -md" router-name="sv001">
          au PAY スマートローントップへ
        </BtnMain>
      </BtngroupSingle>
    </template>
  </div>
</template>

<script>
import { goToErrorPage } from "@/utils/Other";
import { setMeta } from "@/utils/Meta";
import { getUserDataLambdaInvoke } from "@/utils/LambdaHelper";
import { INCOME_CERTIFICATE_IMAGE_AT } from "@/constants/constant";
import HeadingOne from "@/components/heading/HeadingOne";
import WizardGroup from "@/components/wizard/WizardGroup";
import MainWizard from "@/components/wizard/MainWizard";
import StepPage from "@/components/steps/StepPage";
import StepHeader from "@/components/steps/StepHeader";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import TelBox from "@/components/box/TelBox";
export default {
  name: "Tem001",
  components: {
    BtnMain,
    BtngroupSingle,
    StepHeader,
    StepPage,
    MainWizard,
    WizardGroup,
    HeadingOne,
    TelBox,
  },
  setup() {
    setMeta({
      title: "お申し込み完了",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会,本人確認書類",
    });
  },
  data() {
    return {
      userData: {
        identification_document: "",
        revenue_certificate: "",
      },
    };
  },
  computed: {
    isNeedIncome() {
      return (
        (this.userData.revenue_certificate === "02" ||
          this.userData.revenue_certificate === "03") &&
        !window.$cookies.get(INCOME_CERTIFICATE_IMAGE_AT)
      );
    },
  },
  mounted() {
    try {
      getUserDataLambdaInvoke()
        .then((res) => {
          for (let key in res) {
            if (Object.prototype.hasOwnProperty.call(this.userData, key)) {
              this.userData[key] = res[key].toString().trim();
            }
          }
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    } catch (e) {
      goToErrorPage(e);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.steps-box {
  padding: 20px;
  @include mq-down(md) {
    margin-right: -20px;
    margin-left: -20px;
  }
  @include mq-up(md) {
    border-radius: 10px;
  }
  &.-success {
    background-color: $success;
  }
  > .steps-header {
    text-align: center;
    padding: 30px 0px 30px;
    @include mq-up(md) {
      padding: 40px 20px 60px;
    }
    .heading {
      color: $primary;
      font-weight: bold;
      font-size: 20px;
      @include mq-up(md) {
        font-size: 32px;
      }
    }
  }
  > .steps-body {
    background-color: $white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 2px 2px rgba($secondary, 0.6);
    @include mq-up(md) {
      border-radius: 10px;
      padding: 40px;
    }
  }
}

.steps-header.complete {
  padding-bottom: 13px;
}

small.complete-note {
  display: block;
  text-align: left;
  @include mq-down(md) {
    margin-top: 10px;
    margin-bottom: 0;
    line-height: 20px;
  }
  @include mq-up(md) {
    margin-top: 17px;
    margin-bottom: 14px;
    line-height: 24px;
  }
}
</style>
